export default "__VITE_ASSET__CZ9SS7kR__"